const SERIALISE_KEYS = [
  '_toybox',
  '_toyboxRevealed',
  '_scenariosPlayed',
  '_scenarioPlayCount',
  '_toyboxOpened',
];
const MODEL_ID = 'player';

export default class PlayerModel {
  constructor(saves, id) {
    this.saves = saves;
    this._toybox = [];
    this._scenariosPlayed = [];
    this._toyboxRevealed = false;
    this._toyboxOpened = false;
    this._scenarioPlayCount = { 1: 0, 2: 0, 3: 0, 4: 0 };
    this._sessionScenarioPlayCount = { 1: 1, 2: 1, 3: 1, 4: 1 };
    this.load();
  }

  get toyboxOpened() {
    return this._toyboxOpened;
  }

  setToyboxOpened() {
    this._toyboxOpened = true;
    this.save();
  }

  addToToybox(id) {
    if (!this._toybox.find((i) => i == id)) {
      this._toybox.push(id);
      this.save();
    }
  }

  hasToyBoxItems() {
    return this._toybox.length > 0;
  }

  hasToyBoxItem(id) {
    return this._toybox.find((t) => t == id) ? true : false;
  }

  getToyboxItems() {
    return [...this._toybox];
  }

  getToyboxRevealed() {
    return this._toyboxRevealed;
  }

  setToyboxRevealed(value) {
    if (this._toyboxRevealed != value) {
      this._toyboxRevealed = value;
      this.save();
    }
  }

  getSessionScenarioPlayCount(scenarioId) {
    if (scenarioId < 1 || scenarioId > 4) return 1;
    return this._sessionScenarioPlayCount[scenarioId];
  }
  getScenarioPlayCount(scenarioId) {
    if (scenarioId < 1 || scenarioId > 4) return 1;
    return this._scenarioPlayCount[scenarioId];
  }

  addScenarioPlayed(id) {
    if (id >= 1 && id <= 4) {
      let currentCount = this._sessionScenarioPlayCount[id];
      this._sessionScenarioPlayCount[id] = currentCount + 1;
      currentCount = this._scenarioPlayCount[id];
      this._scenarioPlayCount[id] = currentCount + 1;
    }

    if (!this.hasPlayedScenario(id)) {
      this._scenariosPlayed.push(id);
    }
    this.save();
  }

  getScenariosPlayed() {
    return [...this._scenariosPlayed];
  }

  hasPlayedScenario(id) {
    return this._scenariosPlayed.includes(id);
  }

  /*
   * Save Methods
   */
  load() {
    this.saves.deserialize(this, MODEL_ID);
    this.save();
  }

  save() {
    const data = this.saves.serialize(this, MODEL_ID, SERIALISE_KEYS);
    this.saves.save({ data });
  }
}
